import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus, Package } from "lucide-react";
import PackagePickupForm from "./PackagePickupForm";
import { usePermissions } from "@/context/PermissionsContext";

const PackagePickupHeader = () => {
  const [showForm, setShowForm] = useState(false);
  const { hasPermission } = usePermissions();
  
  const canWrite = hasPermission("packagePickup", "write");

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <Package className="h-8 w-8 text-primary" />
            <h1 className="text-3xl font-bold tracking-tight">Pakket Ophaaltijden</h1>
          </div>
          <p className="text-muted-foreground text-lg">
            Registreer dagelijks wanneer de pakketten worden opgehaald door PostNL
          </p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span>📦 Rolcontainers bijhouden</span>
            <span>⏰ Ophaaltijden registreren</span>
            <span>📝 Opmerkingen toevoegen</span>
          </div>
        </div>
        
        {canWrite && (
          <Button 
            onClick={() => setShowForm(true)}
            size="lg"
            className="shadow-md hover:shadow-lg transition-shadow"
          >
            <Plus className="h-5 w-5 mr-2" />
            Nieuwe Ophaling
          </Button>
        )}
      </div>

      <PackagePickupForm 
        open={showForm} 
        onOpenChange={setShowForm}
      />
    </>
  );
};

export default PackagePickupHeader;